import axios from "axios";

const API_URL='https://www.dev.ekhonidaktar.com/api';

class ChangePatientImageService {

    changePatientImage(formData,patient_id){
        let user = JSON.parse(localStorage.getItem('user'));
        const Authorization= 'Bearer ' + user.token;
        return axios.post(`${API_URL}/patients/${patient_id}/image`, formData ,{headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': Authorization
            }
        });
    }

}

export default new ChangePatientImageService();